export const getSortedBooks = (books: any[], sortOption = 'seriesOrder') => {
  return [...books].sort((a, b) => {
    switch (sortOption) {
      case 'alphabetical':
        return a.title.localeCompare(b.title)
      case 'releaseDate':
        return (
          new Date(b.releaseDate).getTime() - new Date(a.releaseDate).getTime()
        )
      case 'seriesOrder':
      default:
        // Sort by series name first, then number
        if (a.series && b.series) {
          if (a.series === b.series) {
            return (a.seriesNumber || 0) - (b.seriesNumber || 0)
          }
          return a.series.localeCompare(b.series)
        }
        // If one has series and other doesn't, series comes first
        if (a.series && !b.series) return -1
        if (!a.series && b.series) return 1
        // Fallback to alphabetical
        return a.title.localeCompare(b.title)
    }
  })
}

export const chunkBooksIntoShelves = (books: any[], itemsPerShelf: number) => {
  const shelves = []
  for (let i = 0; i < books.length; i += itemsPerShelf) {
    shelves.push(books.slice(i, i + itemsPerShelf))
  }
  return shelves
}
